module.exports = __webpack_public_path__ + "media/icecrackthree.74cd36e5.mp3";